import { render } from "./AppSubmenu.vue?vue&type=template&id=5f95a236"
import script from "./AppSubmenu.vue?vue&type=script&lang=js"
export * from "./AppSubmenu.vue?vue&type=script&lang=js"
script.render = render

export default script